import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

const MoveX = 10;
const MoveY = 10;
const Delay = 0.2;
const Stagger = 0.1;
const Duration = 0.6;
const Ease = "circ.out";
const Start = "top 75%";

const scrollAnimation = (
    target,
    x = MoveX,
    y = MoveY,
    delay = Delay,
    stagger = Stagger,
    duration = Duration,
    start = Start
) => {
    if (typeof window !== "undefined") {
        gsap.registerPlugin(ScrollTrigger);
    }

    if ($(target).length) {
        gsap.fromTo(
            target,
            {
                opacity: 0,
                x: x,
                y: y,
            },
            {
                delay: delay,
                x: 0,
                y: 0,
                opacity: 1,
                duration: duration,
                stagger: stagger,
                ease: Ease,
                scrollTrigger: {
                    trigger: target,
                    start: start,
                    // scrub: true,
                },
            }
        );
    }
};

$(document).ready(function () {
    scrollAnimation(".SectionNews_item", 0);
    scrollAnimation(".SectionMedia_item", 0);
    scrollAnimation(".CardPost.Case", undefined, 0);
    scrollAnimation(".articlePopular .CardPost.Column", undefined, 0);
    scrollAnimation(".articleNew .CardPost.Column", undefined, 0);
    scrollAnimation(".Columns .CardPost.Column", undefined, 0);
    scrollAnimation(".SectionFaq_item", 0);
    scrollAnimation(".Layout_card.Price", undefined, 0);
    scrollAnimation(".Layout_card.Home", undefined, 0);
    scrollAnimation(".HomeService_card.anime0", undefined, 0);
    scrollAnimation(".HomeService_card.anime1", undefined, 0);
    scrollAnimation(".HomeService_card.anime2", undefined, 0);
    scrollAnimation(".FooterAreaCta_inner", 0);
    scrollAnimation(
        ".Hero_heading",
        undefined,
        0,
        0.4,
        undefined,
        undefined,
        "top 100%"
    );
    scrollAnimation(
        ".Hero_subHeading",
        undefined,
        0,
        0.4,
        undefined,
        undefined,
        "top 100%"
    );
    scrollAnimation(
        ".Hero_button",
        0,
        undefined,
        0.8,
        undefined,
        undefined,
        "top 100%"
    );
    scrollAnimation(".HeroChild_inner", 0);
    scrollAnimation(".CardButton.Service", undefined, 0);
    scrollAnimation(".ServiceRecom_items .Layout_card", undefined, 0);
    scrollAnimation(".ServiceColumn.anime0", undefined, 0);
    scrollAnimation(".ServiceColumn.anime1", undefined, 0);
    scrollAnimation(".ServiceColumn.anime2", undefined, 0);
    scrollAnimation(".CardButton.Others", undefined, 0);
    scrollAnimation(".FeaturePro_item.large", 0);
    scrollAnimation(".FeaturePro_item.anime0", 0);
    scrollAnimation(".FeaturePro_item.anime1", 0);
    scrollAnimation(".FeaturePro_item.anime2", 0);
    scrollAnimation(".FeaturePro_item.anime3", 0);
    scrollAnimation(".FeaturePro_item.anime4", 0);
    scrollAnimation(".FeaturePro_item.anime5", 0);
    scrollAnimation(".FeaturePro_item.anime6", 0);
    scrollAnimation(".FeatureBound_items.one", 0);
    scrollAnimation(".FeatureBound_items.two", 0);
    scrollAnimation(".FeatureSec_item", undefined, 0);
    scrollAnimation(".FeatureSupport_items .Layout_card", undefined, 0);
    scrollAnimation(".Company_items .CardButton", undefined, 0);
    scrollAnimation(".MessagePolicy_item", undefined, 0);
    scrollAnimation(".MessageGreeting_box", 0);
});
